import { $, each } from '../util'

const LoginPanel = (() => {
  const toggleLoginPanel = () => {
    const opener = $('.js-open-login-panel')
    const closer = $('.js-close-login-panel')

    each(opener, (i, op) => {
      op.addEventListener('click', () => {
        document.body.classList.add('is-login-panel-open')
      })
    })

    each(closer, (i, cl) => {
      cl.addEventListener('click', () => {
        document.body.classList.remove('is-login-panel-open')
      })
    })
  }

  const init = () => {
    toggleLoginPanel()
  }

  return {
    init
  }
})()

export default LoginPanel



// WEBPACK FOOTER //
// app/javascript/scripts/components/LoginPanel.js